<!--

	A long label that indicates that the course is in development.

-->
<template>
	<tippy :placement="isDesktop ? tippyPlacement : 'bottom'" :interactive="true" content-class="left-align" class="mia-InDevelopmentLabelLong">
		<span class="label mia-label mia-label-warning" @click.prevent.stop>
			<span v-tr="`course_in_development`" />
			<inline-svg src="@theme/icons/in_development_icon.svg" />
		</span>
		<template #content>
			<span v-tr="labelTextResource" />
		</template>
	</tippy>
</template>
<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import { ScreenSize } from "../utils/ScreenSize";
import InlineSvg from "vue-inline-svg";
import { Tippy } from "vue-tippy";

@Component({
	components: { InlineSvg, Tippy },
})
export class InDevelopmentLabelLong extends Vue {
	@Prop({ required: true, type: Object }) labelTextResource!: string;
	@Prop({ required: false, type: String, default: "bottom" }) tippyPlacement!: string;

	get isDesktop() {
		return ScreenSize.isDesktop();
	}
}

export default toNative(InDevelopmentLabelLong);
</script>
<style lang="scss">
.mia-InDevelopmentLabelLong {
	display: inherit;

	svg {
		margin-left: theme.$mia-margin-size-small;
	}
}
</style>
